import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  SelectQuestionModel,
  MultipleQuestionModel,
  ExplainQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { PermitVisitorCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'visitor-policy',
  templateUrl: './visitor.component.html',
})
export class VisitorComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = PermitVisitorCopy;
  provePermit = new RadioQuestionModel();
  permitCancellation = new SelectQuestionModel();
  permitMistake = new MultipleQuestionModel();
  explain = new ExplainQuestionModel();

  permitTypes: Array<{ value: string; text: string }> = [];
  selectedPermitTypes: Array<number>;
  differentName = '';

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setPermitTypes();
    this.setProvePermitQuestion();
    this.setPermitCancellationQuestion();
    this.setPermitMistakeQuestion();
    this.setExplainQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setPermitTypes() {
    this.permitTypes = [
      { value: 'n', text: 'Paper permits where drivers fill in or scratch off details' },
      {
        value: 'n',
        text: "Paper permits where drivers don't enter any information: the information on the permit is fixed",
      },
      { value: 'n', text: 'Virtual permits' },
    ];
  }
  onSelectPermitType(document) {
    document.value = document.value === 'n' ? 'y' : 'n';
  }

  setProvePermitQuestion() {
    this.provePermit.data = {
      title: this.textCopy.provePermitTitle,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'yes – provided it was displayed (even if it was wrongly displayed)', value: 'd' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onProvePermitSelected(answerValue) {
    this.provePermit.valueSelected = answerValue;
  }

  setPermitCancellationQuestion() {
    this.permitCancellation.data = {
      title: this.textCopy.permitCancellationTitle,
      includeTitle: true,
      answers: [
        { id: '0', value: '1' },
        { id: '1', value: '2' },
        { id: '2', value: '3' },
      ],
    };
  }
  onPermitCancellationSelected(answerValue) {
    this.permitCancellation.valueSelected = answerValue;
  }

  setPermitMistakeQuestion() {
    this.permitMistake.data = {
      questions: [
        {
          id: 0,
          text: 'Wrong VRM detail (a wrong digit or two)',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 1,
          text: 'Wrong zone or location',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 2,
          text: 'Wrong year',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 3,
          text: 'Wrong month',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 4,
          text: 'Wrong date (eg 31st)',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 5,
          text: 'Wrong day (eg Tuesday)',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 6,
          text: 'Wrong start time / parked before start time',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 7,
          text: 'Wrong length of session bought (eg a one-hour rather than two-hour session)',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
        {
          id: 8,
          text: 'Session cancelled by account holder',
          answers: [
            { id: 'n', value: '0' },
            { id: '0', value: '1' },
            { id: '1', value: '2' },
            { id: '2', value: '3' },
          ],
        },
      ],
    };
  }
  onPermitMistakeSelected(answerValue) {
    this.permitMistake.valuesSelected = answerValue;
  }

  setExplainQuestion() {
    this.explain.data = {
      title: this.textCopy.explainTitle,
      includeTitle: true,
      name: "'Resident permit holders'",
      validList: ['0', '1', '2', '3', '4', '5', '7', '8', '9', '10'],
      exampleItem: "Visitors' permits",
    };
  }
  onExplainSelected(answerValue) {
    this.explain.valueSelected = answerValue.answerSelected;
    this.explain.validationSelected = answerValue.validationSelected;
    this.explain.validationText = answerValue.validationText;
  }

  setSelectedValues() {
    this.permitTypes[0].value = this.policiesAnswers['19_1_1'];
    this.permitTypes[1].value = this.policiesAnswers['19_1_2'];
    this.permitTypes[2].value = this.policiesAnswers['19_1_3'];
    this.differentName = this.policiesAnswers['19_2'];
    this.provePermit.valueSelected = this.policiesAnswers['19_4'];
    this.permitCancellation.valueSelected = this.policiesAnswers['19_5'];
    this.permitMistake.valuesSelected = [
      { id: 0, value: this.policiesAnswers['19_3_1'] },
      { id: 1, value: this.policiesAnswers['19_3_2'] },
      { id: 2, value: this.policiesAnswers['19_3_3'] },
      { id: 3, value: this.policiesAnswers['19_3_4'] },
      { id: 4, value: this.policiesAnswers['19_3_5'] },
      { id: 5, value: this.policiesAnswers['19_3_6'] },
      { id: 6, value: this.policiesAnswers['19_3_7'] },
      { id: 7, value: this.policiesAnswers['19_3_8'] },
      { id: 8, value: this.policiesAnswers['19_3_9'] },
    ];
    this.explain.validationSelected = this.policiesAnswers['19_7'];
    this.explain.valueSelected = this.policiesAnswers['19_6'];
    this.explain.validationText = this.policiesAnswers['19_8'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '19_2', description: this.differentName },
      { id: '19_4', description: this.provePermit.valueSelected },
      { id: '19_5', description: this.permitCancellation.valueSelected },
      { id: '19_7', description: this.explain.validationSelected },
      { id: '19_6', description: this.explain.valueSelected },
      { id: '19_8', description: this.explain.validationText },
    ];

    this.permitTypes.forEach((selectedValue, index) => {
      policyList.push({ id: `19_1_${index + 1}`, description: selectedValue.value });
    });
    this.permitMistake.valuesSelected.forEach((selectedValue, index) => {
      policyList.push({ id: `19_3_${index + 1}`, description: selectedValue.value });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
